export default __webpack_public_path__ + "images/logo-lenton.svg?9742b9d479df7f88518868fb622a0bb9";